<template>
  <div>
    <h1>BIZTOSÍTÁSI FEDEZET</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Visszamenőleges hatály:
        <span
          class="info"
          name="fed_visszamenoleges_hataly-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?</span
        ></label
      >
      <div class="col-sm-8">
        Teljes visszamenőleges hatály
      </div>
    </div>
    <!-- <h2>
      Kártérítési limit duplán történő felhasználhatósága<span
        class="info"
        id="duplalimit-tooltip"
        data-toggle="tooltip"
        data-placement="right"
        title=""
      >
        ?</span
      >
    </h2> -->
    <div class="mb-2">
      <b class="sub">Szublimitek és speciális kiegészítő limitek:</b>
    </div>

    <div class="form-group row mb-2">
      <label class="col-sm-4">Sürgős jogvédelmi költségekre vonatkozó szublimit:</label>
      <div class="col-sm-8">
        Teljes kártérítési limit
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Kárigény érvényesítését megelőző vizsgálatra vonatkozó szublimit:</label
      >
      <div class="col-sm-8">
        Teljes kártérítési limit
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Kárkörülményekkel kapcsolatos kárenyhítésre vonatkozó szublimit:</label
      >
      <div class="col-sm-8">
        Teljes kártérítési limit
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Jó hírnév sérelmének orvoslásával összefüggő költségek szublimitje:</label
      >
      <div class="col-sm-8">
        Teljes kártérítési limit
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Kárigény miatt fellépő stressz betegség esetén szükséges pszichológiai ellátás költségére
        vonatkozó szublimit:</label
      >
      <div class="col-sm-8">
        A kártérítési limit 10%-a, de max. 5 millió Ft
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A cégautó pótlási költségére vonatkozó szublimit:</label>
      <div class="col-sm-8">
        A kártérítési limit 10%-a, de max. 5 millió Ft
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4"
        >Nem ügyvezető igazgatósági tagok speciális kiegészítő fedezetéhez kapcsolódó kiegészítő
        limit:</label
      >
      <div class="col-sm-8">
        A kártérítési limit 20%-a, de max. 300 millió Ft
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Önrészesedés:</label>
      <div class="col-sm-8">
        Önrészesedés nem kerül felszámításra, csak és kizárólag a Biztosítási fedezet D rész -
        Társasági értékpapír fedezet alatt érvényesített kárigények tekintetében, amelyekre
        vonatkozóan az önrészesedés összege 1 000 000 Ft kárigényenként.
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Területi hatály:</label>
      <div class="col-sm-8">
        az egész világ
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Kiterjesztett kárbejelentési időszak:</label>
      <div class="col-sm-8">
        12 hónap automatikus kárbejelentési időszak díjmentesen.
        <br />Távozó vezető tisztségviselők korlátlan időre szóló kárbejelentési időszaka
        díjmentesen.
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';

export default {
  components: {},
  computed: {
    ...mapFields(['currency', 'insuranceYearlyPrice', 'eves_dij']),
  },
  mounted() {
    this.$store.dispatch('updateMarks');
  },
};
</script>
<style lang="scss">
$red: #e4002b;
.sub {
  color: $red;
  margin-bottom: 10px;
}
</style>
